export default __webpack_public_path__ + "static/vehicle_placeholder-49cfb284771d140186813b5ea75fd817.svg";